export const Colors = {
    primaryColor: '#2B2B2B',
    disabledTextColor: '#adadad',
    secondaryColor: '#CCCCCC',
    thirdColor: '#E8E8E8',
    fourthColor: '#F3F3F3',
    black: '#000',
    white: '#fff',
    greenWhatsApp: '#25D366',
};